import React, { useEffect, useState } from 'react';
import DocumentList from '../../components/Document/shipWiseDocumentList/index';
import ShipList from '../../components/Document/shipWiseDocumentList/ships';

import SearchBar from '../../components/Document/shipWiseDocumentList/searchFilter';
import Layout from '../../components/common/pageLayout';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_ship_wise_document_count } from '../../actions/v3/document';
import constant from '../../constant';
import { toast } from 'react-toastify';
import DocumentDetail from '../../components/Document/shipWiseDocumentList/DocumentDetail';
import { replacePageState } from '../../utils';

const ProjectWiseDocumentCount = (props) => {

    const location = useLocation();
    const { page, data: encodedData, selectedShip: selectedShipIndex } = location.state || {};
    const [ships, setShips] = useState({});
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');
    const [selectedShip, setSelectedShip] = useState(selectedShipIndex || 0);
    const [selectedDocument, setSelectedDocument] = useState('');
    const [refresh, setRefresh] = useState(false)


    useEffect(() => {
        fetchProjects();
    }, [currentPage, limit, refresh]);

    const fetchProjects = () => {
        v3_ship_wise_document_count(JSON.parse(atob(encodedData))['PROJECT_ID']).then((res) => {
            if (res.status) {
                setShips(res.result.ships);

                // setSelectedDocument('')
                replacePageState(props.history, constant.Authedcomponent.shipDocument.url, {
                    page: currentPage,
                    data: encodedData
                });
            } else {
                toast.error(res.error || "Failed to fetch hull list");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Something went wrong");
        });
    };


    return (
        <Layout title={`Documents | ${JSON.parse(atob(encodedData))['PROJECT_NAME']}`}>
            <SearchBar
                onSearch={(newPayload) => { setPayload(newPayload) }}
                onReset={() => { setPayload('') }}
                encodedData={encodedData}
            />
            <div className='row'>
                <div className='col-lg-3 pd0'>
                    <ShipList
                        ships={ships}
                        selectShip={setSelectedShip}
                        selected={selectedShip}
                    />
                </div>
                <div className={`col-lg-${selectedDocument ? '6' : '9'} pd0 pdlr0'`}>
                    <DocumentList
                        payload={payload}
                        selectedDocument={selectedDocument}
                        setSelectedDocument={setSelectedDocument}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        shipId={ships[selectedShip]?.SHIP_ID}
                        encodedData={encodedData}
                        selectedShip={selectedShip}
                        limit={limit}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
                {selectedDocument && <div className='col-lg-3 pd0'>
                    <DocumentDetail
                        refresh={refresh}
                        setRefresh={setRefresh}
                        data={selectedDocument}
                    />
                </div>}
            </div>

        </Layout>
    );
};

export default ProjectWiseDocumentCount;
